export const USERNAME = 'username';
export const ID_USER = 'id_user';
export const EMAIL = 'email';
export const CURRENT_ITEMS = 'current_items';
export const TOKEN = 'token';
